module.exports = __webpack_public_path__ + "img/sanderson-logo.6c3ff967.png";